import { Toggle } from '@/components/ui/toggle';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { cn } from '@/lib/cn';
import type { Tooltip as ToolTipPrimitive } from 'radix-ui';
import * as React from 'react';

interface ToolbarButtonProps extends React.ComponentPropsWithoutRef<
  typeof Toggle
> {
  isActive?: boolean;
  tooltip?: string;
  tooltipOptions?: ToolTipPrimitive.TooltipContentProps;
}

export const ToolbarButton = React.forwardRef<
  HTMLButtonElement,
  ToolbarButtonProps
>(
  (
    { isActive, children, tooltip, className, tooltipOptions, ...props },
    ref
  ) => {
    if (!tooltip) {
      return (
        <Toggle
          size='sm'
          ref={ref}
          className={cn('size-8 p-0', { 'bg-accent': isActive }, className)}
          {...props}
        >
          {children}
        </Toggle>
      );
    }

    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <Toggle
            size='sm'
            ref={ref}
            className={cn('size-8 p-0', { 'bg-accent': isActive }, className)}
            {...props}
          >
            {children}
          </Toggle>
        </TooltipTrigger>
        <TooltipContent {...tooltipOptions}>
          <div className='flex flex-col items-center text-center'>
            {tooltip}
          </div>
        </TooltipContent>
      </Tooltip>
    );
  }
);

ToolbarButton.displayName = 'ToolbarButton';
